"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_color-preview.scss");

var _reactPopover = _interopRequireDefault(require("react-popover"));

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ColorPreview = /*#__PURE__*/function (_Component) {
  _inherits(ColorPreview, _Component);

  var _super = _createSuper(ColorPreview);

  function ColorPreview() {
    var _this;

    _classCallCheck(this, ColorPreview);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "toggleSelectColor", function () {
      _this.setState(function (_ref) {
        var colourPickerVisible = _ref.colourPickerVisible;
        return {
          colourPickerVisible: !colourPickerVisible
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeColorPicker", function () {
      _this.setState({
        colourPickerVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleColorPickerSaveColor", function (_ref2) {
      var hex = _ref2.hex,
          label = _ref2.label;
      var handleSaveColor = _this.props.handleSaveColor;
      handleSaveColor({
        hex: hex,
        label: label
      });
      return void _this.closeColorPicker();
    });

    _this.state = {
      colourPickerVisible: false
    };
    return _this;
  }

  _createClass(ColorPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          hexCode = _this$props.hexCode,
          colorName = _this$props.colorName,
          isSecondarySection = _this$props.isSecondarySection,
          handleRemoveClick = _this$props.handleRemoveClick;
      var colourPickerVisible = this.state.colourPickerVisible;
      var initialValue = {
        hex: hexCode,
        label: colorName
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "color-preview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "color-preview__sample",
        style: {
          backgroundColor: "#".concat(hexCode)
        }
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "color-preview__title",
        ellipsisOverflow: true,
        noMargin: true
      }, colorName), isSecondarySection || index !== 0 ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        prefix: "trash",
        onClick: handleRemoveClick
      }) : null, /*#__PURE__*/_react.default.createElement(_reactPopover.default, {
        className: "color-preview__popover",
        isOpen: colourPickerVisible,
        onOuterAction: this.closeColorPicker,
        preferPlace: "right",
        tipSize: 0.01,
        enterExitTransitionDurationMs: 0,
        body: /*#__PURE__*/_react.default.createElement(_uiKit.ColorPicker, {
          initialValue: initialValue,
          onSaveColor: this.handleColorPickerSaveColor
        })
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        prefix: "edit",
        onClick: this.toggleSelectColor
      })));
    }
  }]);

  return ColorPreview;
}(_react.Component);

_defineProperty(ColorPreview, "defaultProps", {
  buttonText: 'Edit Color'
});

var _default = ColorPreview;
exports.default = _default;